import { useEffect, useState } from "react"
import { ConnectUser } from "../api/ConnectApi"
import { useTranslation } from "react-i18next"
import { GET_ACTIVITY_TASKCHANGES } from "../api/QuadriApi"
import { useQuery } from "@apollo/client"

export interface UserRowProps {
  connectProjectId: string
  userId: string
  user?: ConnectUser
  quadriProjectId?: string
  activityType?: string
  activityIds?: number[]
  taskId?: number
  getTaskChanges?: boolean
}

export const UserRow = (props: UserRowProps) => {
  const { taskId, quadriProjectId, activityType, activityIds } = props
  const [desired_taskChange, setDesired_taskChange] = useState<string | undefined>("")
  const { t } = useTranslation("tasks")

  const { loading, error, data } = useQuery(GET_ACTIVITY_TASKCHANGES, {
    variables: {
      quadriProjectId,
      activityType,
      activityIds
    },
    errorPolicy: "all",
    skip: !props.getTaskChanges
  })

  useEffect(() => {
    if (data) {
      const taskChanges = data?.getTaskChangesForAnActivity
      const d_taskChange = taskChanges?.find((item: any) => item.taskId === taskId?.toString())
      if (d_taskChange?.changeType === "New") {
        setDesired_taskChange(t("tasksChanges.new").toUpperCase())
      } else if (d_taskChange?.changeType === "Updated") {
        setDesired_taskChange(t("tasksChanges.updated").toUpperCase())
      } else if (d_taskChange?.changeType === "Deleted") {
        setDesired_taskChange(t("tasksChanges.deleted").toUpperCase())
      }
    }
  }, [data, taskId, t])

  if (props.getTaskChanges && loading) {
    return <div>{t("tasksActivities.loading")}</div>
  } else if (props.getTaskChanges && error) {
    return (
      <div>
        <p>{t("tasksActivities.errLoadingDetails")}</p>
        <p>{error.message}</p>
      </div>
    )
  }

  return (
    <div className="row-center justify-content-between">
      <div className="d-flex">
        <div className="mr-2 avatar small borderless">
          <Thumbnail {...props} />
        </div>
        <div className="text-ellipsis">
          <UserLink {...props} />
          <EmployerField {...props} />
        </div>
      </div>
      <div style={{ fontWeight: "500" }}>{desired_taskChange}</div>
    </div>
  )
}

const Thumbnail = (props: UserRowProps) => {
  const { user } = props
  if (user) {
    const { thumbnail } = user
    const thumbnailUrl = thumbnail.includes("?")
      ? `${thumbnail}&accessToken=${localStorage.getItem("tc-access-token")}`
      : thumbnail
    return <img src={thumbnailUrl} alt={`thumbnail ${userFullName(user)}`} />
  } else {
    return <></>
  }
}

const UserLink = (props: UserRowProps) => {
  const { connectProjectId, userId, user } = props
  if (user) {
    const link = `https://web.connect.trimble.com/projects/${connectProjectId}/team/${user.id}`
    return (
      <h5 className="text-ellipsis">
        <a href={link} target="_blank" rel="noreferrer" className="link-secondary">
          {/* <a href={link} target="_parent" className="link-secondary"> /* Navigating parent window does not work */}
          {userFullName(user)}
        </a>
      </h5>
    )
  } else {
    return <>(User ID: {userId})</>
  }
}

const EmployerField = (props: UserRowProps) => {
  if (props.user) {
    const companyName = props.user.company?.name
    return <>{companyName && <small className="text-meta text-ellipsis">{companyName}</small>}</>
  } else {
    return <></>
  }
}

export const userFullName = (user?: ConnectUser) => (user ? `${user.firstName} ${user.lastName}` : "")
